import {ModelPrompt} from 'webmodals/model-prompt.es6'

class ConsumerShippingLocationPrompt extends ModelPrompt {
    constructor($uibModal, $session) {
        super($uibModal);
        this.seed = Object.assign({}, $session);
    }
    getTitle(model, action){return `${action} shipping location...`}
    getQueryUrl(model, action){return `QueryConsumerShippingLocations.json?Id=${model && model.id}`;}
    getCommandUrl(model, action){ return `${action}ConsumerShippingLocation.json`;}
    getModalBodyTemplateUrl(model, action){ return `consumer-shipping-location-${action === 'Delete' ? 'delete-confirmation' : 'fieldset'}.html`;}
}

export default ConsumerShippingLocationPrompt

angular.module('emun.consumer').service('consumerShippingLocationPrompt', ConsumerShippingLocationPrompt);